import { FIXED_ONE } from "@newfungame/contracts";

interface NumberEffect {
  id: number;
  kind: string;
  pos: { x: number; y: number };
  value: number;
}

export interface PlannedNumber {
  value: number;
  crit: boolean;
}

/**
 * Цифры урона без каши (#38): удары по одной цели (клетка 1×1) складываются в одну цифру на самом новом эффекте,
 * остальные скрыты; одновременно — не больше `max` (сначала криты, затем крупные). Эффекты вне плана не рисуются.
 */
export function planDamageNumbers(effects: readonly NumberEffect[], max: number): Map<number, PlannedNumber> {
  const groups = new Map<string, { id: number; value: number; crit: boolean }>();
  for (const e of effects) {
    if (e.kind !== "damageNumber" && e.kind !== "critNumber") continue;
    const key = `${Math.round(e.pos.x / FIXED_ONE)}:${Math.round(e.pos.y / FIXED_ONE)}`;
    const g = groups.get(key);
    const crit = e.kind === "critNumber";
    if (!g) groups.set(key, { id: e.id, value: e.value, crit });
    else {
      g.value += e.value;
      g.crit ||= crit;
      if (e.id > g.id) g.id = e.id;
    }
  }
  const list = [...groups.values()].sort((a, b) => Number(b.crit) - Number(a.crit) || b.value - a.value);
  const out = new Map<number, PlannedNumber>();
  for (const g of list.slice(0, max)) out.set(g.id, { value: g.value, crit: g.crit });
  return out;
}
